var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2438 4.0275L13.9725 2.75625C13.2975 2.08125 12.2006 2.08125 11.5256 2.75625L9.39375 4.89375L3.09938 11.1825C2.54813 11.7337 2.25 12.4594 2.25 13.2356V15.1875C2.25 15.4969 2.50312 15.75 2.8125 15.75H4.76438C5.54063 15.75 6.26625 15.4462 6.8175 14.9006L13.1119 8.61188L15.2438 6.47438C15.57 6.14813 15.75 5.715 15.75 5.25375C15.75 4.7925 15.57 4.35938 15.2438 4.03313V4.0275ZM6.01875 14.1019C5.68125 14.4394 5.23688 14.625 4.76438 14.625H3.375V13.2356C3.375 12.7631 3.56062 12.3131 3.89812 11.9812L9.79313 6.09188L11.9194 8.21812L6.02437 14.1131L6.01875 14.1019ZM14.4506 5.67563L12.7181 7.41375L10.5919 5.2875L12.3244 3.54937C12.5606 3.31313 12.9431 3.31313 13.1794 3.54937L14.4506 4.82062C14.5631 4.93312 14.625 5.085 14.625 5.24813C14.625 5.41125 14.5631 5.5575 14.4506 5.67563ZM14.625 14.625H9C8.69063 14.625 8.4375 14.8781 8.4375 15.1875C8.4375 15.4969 8.69063 15.75 9 15.75H14.625C14.9344 15.75 15.1875 15.4969 15.1875 15.1875C15.1875 14.8781 14.9344 14.625 14.625 14.625Z",
    fill: "#A37C4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.2ec8ac6b66f9849d802d4bebf6bc5e9a.svg";
export { ForwardRef as ReactComponent };